export const brandColor = {
  brand1: '#0E67DAFF',
  brand2: '#165DFF99',
  brand3: '#0B52AEFF',
  brand4: '#165DFF1A'
}
